import { render, staticRenderFns } from "./AddTaxByPerson.vue?vue&type=template&id=3efbd58a&"
import script from "./AddTaxByPerson.vue?vue&type=script&lang=js&"
export * from "./AddTaxByPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports